import React from "react";
import { Helmet } from "react-helmet";
import Header from "../../../components/default/header";
import CardListData from "./cardData";
import SidebarMenu from "../menu/sidebarMenu";
import Breadcrumb from "../../default/breadcrumb/breadcrumb";


const CardList = () => {
    return (
        <div className="menu-with-settings sidebar-menu-enable">
            <Helmet><title>Card List - Cardiast</title></Helmet>
            <Header />
            <div className="sidebar-with-content ds-flex">
                <SidebarMenu />
                <div className="content-right">
                    <Breadcrumb />
                    <CardListData />
                </div>
            </div>
        </div>
        
    );
}

export default CardList;
